import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_EVICTION } from 'config/formSections/financial';
import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import { DateSummary, Summary } from 'components/Summary';
import EvictionItem from './EvictionItem';

const sectionConfig = {
  key: FINANCIAL_EVICTION.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_EVICTION.name,
  storeKey: FINANCIAL_EVICTION.storeKey,
};

export class Eviction extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const date = DateSummary(o.When);
    const propertyLocation = o?.PropertyLocation?.city && o?.PropertyLocation?.state ? `${o.PropertyLocation?.city}, ${o.PropertyLocation?.state}` : '';

    return Summary({
      type: i18n.t('financial.pvq.eviction.summary.type'),
      index,
      left: propertyLocation,
      right: date,
      placeholder: i18n.t('financial.pvq.eviction.summary.unknown'),
    });
  };

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasEviction: this.props.HasEviction,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasEviction = (values) => {
    this.update({
      HasEviction: values,
      List: values?.value === "No" ? {} : this.props.List,
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content eviction"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_EVICTION.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.eviction')}</h1>
        <Branch
          name="has_eviction"
          label={i18n.t('financial.pvq.eviction.branch.title')}
          labelSize="h4"
          className="eviction-branch"
          {...this.props.HasEviction}
          warning
          onUpdate={this.updateHasEviction}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="HasEviction"
        />
        {this.props.HasEviction?.value === 'Yes' && (
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            summary={this.summary}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.eviction.appendTitle')}
            attribute="List"
          >
            <EvictionItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        )}
      </div>
    );
  }
}

Eviction.defaultProps = {
  onUpdate: () => { },
  onError: (value, arr) => arr,
  dispatch: () => { },
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Eviction, sectionConfig);
